import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 세션 확인
  const checkSession = useCallback(async () => {
    try {
      const response = await fetch('/api/auth/session', {
        method: 'GET',
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setIsLoggedIn(true);
          setUser(data.user);
          sessionStorage.setItem('user', JSON.stringify(data.user));
        } else {
          setIsLoggedIn(false);
          setUser(null);
          sessionStorage.removeItem('user');
        }
      } else {
        setIsLoggedIn(false);
        setUser(null);
        sessionStorage.removeItem('user');
      }
    } catch (error) {
      console.error('Session check error:', error);
      setIsLoggedIn(false);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // 앱 시작시 세션 확인
  useEffect(() => {
    checkSession();
  }, [checkSession]);

  // 로그인
  const login = useCallback((userData) => {
    setIsLoggedIn(true);
    setUser(userData);
    sessionStorage.setItem('user', JSON.stringify(userData));
  }, []);

  // 로그아웃
  const logout = useCallback(async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'GET',
        credentials: 'include'
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsLoggedIn(false);
      setUser(null);
      sessionStorage.removeItem('user');
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, isLoading, login, logout, checkSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
